<template>
  <div>
    <ui-header
      title="KybCompanySearch"
      :method="searchMethod"
      method-get
      no-extra-payload
      :filters="filters"
      :disabled="isLoading"
      :auto-refresh="false"
      @startSearch="startSearch"
      @finishSearch="finishSearch"
    >
      <ui-button
        class="btn multiple-entries-btn"
        small
        @click="showImportModal"
      >
        {{ $t('KybMonitoringBatchUploadManageList') }}
      </ui-button>
      <ui-header-input
        v-model="filters.CompanyCode"
        placeholder="HeaderCompanyCodePlaceholder"
        icon="la-institution"
        wide
        :disabled="isLoading"
      />
      <ui-header-dropdown
        v-model="filters.date"
        :options="monitoringSetupDateOptions"
        placeholder="KybMonitoringAllPeriod"
        wide
        :disabled="isLoading"
      />
    </ui-header>
    <ui-container>
      <ui-card icon="la la-institution">
        <template v-if="!isLoading">
          <ui-table
            :labels="tableLabels"
            class="hide-mobile"
            :data="companies"
            :loading="isLoading"
            empty-text="DetailsKybNotFound"
          >
            <template v-if="companies">
              <tr
                v-for="(row, index) in companies"
                :key="index"
                class="m-table__row"
                :class="{
                  'status-pending': row.requestStatus === 'Pending',
                  'status-rejected': row.requestStatus === 'Rejected'
                }"
              >
                <td>{{ row.name }}</td>
                <td>{{ row.code }}</td>
                <td>{{ row.localDate }}</td>
                <td class="td-link">
                  <ui-button
                    type="button"
                    class="btn-brand"
                    @click="clickViewButton(row.code)"
                  >
                    {{ $t('TableView') }}
                  </ui-button>
                </td>
                <td class="td-link">
                  <ui-button
                    type="button"
                    class="btn-brand"
                    @click="undoMonitoring(row.code)"
                  >
                    {{ $t('KybUndoMonitoring') }}
                  </ui-button>
                </td>
              </tr>
            </template>
          </ui-table>
          <template v-if="companies">
            <div
              v-for="(row, index) in companies"
              :key="index"
              class="response-table show-mobile"
            >
              <responsive-table-tr
                title="DetailsCompanyName"
                :value="row.name"
              />
              <responsive-table-tr
                title="DetailsCompanyCode"
                :value="row.code"
              />
              <responsive-table-tr
                title="KybStartedMonitoring"
                :value="row.localDate"
              />
              <div class="m--margin-top-10">
                <ui-button
                  type="button"
                  class="btn-brand big-link"
                  @click="clickViewButton(row.code)"
                >
                  {{ $t('TableView') }}
                </ui-button>
              </div>
              <div class="m--margin-top-10">
                <ui-button
                  type="button"
                  class="btn-brand"
                  @click="undoMonitoring(row.code)"
                >
                  {{ $t('KybUndoMonitoring') }}
                </ui-button>
              </div>
            </div>
          </template>
          <div v-else class="table-message show-mobile">
            {{ $t('DetailsKybNotFound') }}
          </div>
        </template>
        <ui-loader v-else :size="4" center />
        <ui-page-selector
          :active-page="pageSelectorData.page"
          :items-count="pageSelectorData.count"
          :max-on-page="pageSelectorData.pageSize"
          :disabled="isLoading"
          @change="pageChanged"
        />
      </ui-card>
      <pop-up>
        <batch-list-upload @updateCompanies="updateCompanies" />
      </pop-up>
    </ui-container>
  </div>
</template>

<script>
import ResponsiveTableTr from '@src/components/partials/ResponsiveTableTr'
import BatchListUpload from './../../BatchListUpload'

import Api from '@src/scripts/api'
import {
  dateToString,
  createMonitoringSetupDateOptions
} from '@src/scripts/helpers'
import { API } from '@src/scripts/enums'

export default {
  components: {
    ResponsiveTableTr,
    BatchListUpload
  },

  props: {
    changePage: { type: Function, default: undefined }
  },

  data() {
    return {
      searchMethod: API.MONITORING_COMPANIES,
      filters: {
        CompanyCode: null,
        date: null,
        page: 1
      },
      monitoringSetupDateOptions: createMonitoringSetupDateOptions(),
      pageSelectorData: {
        page: 1,
        pageSize: 30,
        count: 0
      },
      companies: [],
      isLoading: false,
      tableLabels: [
        'DetailsCompanyName',
        'DetailsCompanyCode',
        'KybStartedMonitoring',
        '',
        ''
      ]
    }
  },

  methods: {
    startSearch() {
      this.isLoading = true
      this.pageSelectorData.page = 1
    },

    finishSearch(response) {
      if (!response.companies) return

      const { count, page, pageSize, companies } = response
      this.companies = companies.map((item) => ({
        ...item,
        localDate: dateToString(item.added, true)
      }))
      this.pageSelectorData = {
        page,
        pageSize,
        count
      }
      this.isLoading = false
    },

    updateCompanies() {
      const searchBtn = document.querySelector('button[type="submit"]')
      searchBtn?.click()
    },

    clickViewButton(companyCode) {
      this.$router.push({
        name: 'KybPageDetails',
        params: { companyCode, countryCode: 'Lt' }
      })
    },

    async undoMonitoring(companyCode) {
      try {
        await Api.del(API.MONITORING_COMPANIES, {
          companyCodes: [companyCode],
          country: 'Lt'
        })
        this.companies = this.companies.filter(
          (company) => company.code !== companyCode
        )
      } catch (error) {
        this.$notify({
          title: 'ErrorUnknownTitle',
          message: 'ErrorUnknownDescription'
        })
        return null
      }
    },

    pageChanged(value) {
      this.pageSelectorData.page = value
      this.$emit('changePage', value, this.filters)
    },

    showImportModal(e) {
      e.preventDefault()
      this.$openPopUp()
    }
  }
}
</script>

<style scoped>
@media (min-width: 679px) {
  .multiple-entries-btn {
    position: absolute;
    width: auto;
    top: 2rem;
    right: 2rem;
  }
}

@media (max-width: 678px) {
  .multiple-entries-btn {
    position: relative;
    width: 100%;
    margin-bottom: 1rem;
  }
}

.table-message {
  text-align: center;
  background-color: #fffbf6;
  margin-top: -0.5rem;
}

.response-table {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.italic-text {
  font-style: italic;
  color: red;
}

.margin-right {
  margin-right: 1rem;
}

.show-mobile {
  display: none;
}

@media all and (max-width: 992px) {
  .show-mobile {
    display: block;
  }

  .show-mobile table {
    border: 0;
  }

  .show-mobile tr td table {
    width: 100%;
    table-layout: fixed;
  }

  .show-mobile tr td {
    border: 0;
  }

  .show-mobile tr.m-table__row > td {
    border-bottom: 1px solid rgb(235, 237, 242);
  }

  .hide-mobile {
    display: none;
  }
}

@media (max-width: 400px) {
  .big-link {
    width: 100%;
    display: block;
    margin-bottom: 0.5rem;
  }
}
</style>
